import { render } from "./AccountDetailsDetailsCol.vue?vue&type=template&id=a9fb2ea4"
import script from "./AccountDetailsDetailsCol.vue?vue&type=script&lang=js"
export * from "./AccountDetailsDetailsCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__